import { makeVar } from '@apollo/client'

/**
 * Client-only record of the order notifications were pinned during this
 * session — a map of notification identifier to a monotonically increasing
 * counter, where a higher value means more recently pinned.
 *
 * The backend exposes only `isPinned` (no pin timestamp and no pin-aware sort),
 * so the Inbox tracks pin recency here to show the most recently pinned
 * notification first in the "Pinned" group. This is transient: it resets on
 * reload, where pinned items fall back to the backend's creation-date order.
 */
export const pinOrderVar = makeVar<Record<string, number>>({})

let pinCounter = 0

/** Record that a notification was just pinned, moving it to the top. */
export const recordPinned = (identifier: string) => {
  pinCounter += 1
  pinOrderVar({ ...pinOrderVar(), [identifier]: pinCounter })
}

/** Forget a notification's pin order once it's unpinned. */
export const recordUnpinned = (identifier: string) => {
  const { [identifier]: _removed, ...rest } = pinOrderVar()
  pinOrderVar(rest)
}
